// Reputation inbox (public Google reviews, /admin/marketing/reputation).
//
// Hidden: the inbox depends on the Google Business Profile API, and Google
// declined our access request. Until that is approved the page cannot
// connect or pull reviews, so the sidebar item, the Marketing tab and the
// route itself are switched off here. The page, API client and backend are
// left intact — flip this to true to bring the feature back.
export const REPUTATION_INBOX_ENABLED: boolean = false
